import { keyframes } from '@emotion/react';

export const spinIn = keyframes`
  from {
    scale: 0.3;
    rotate: 60deg;
  }
  to {
    scale: 1;
    rotate: 0deg;
  }
`;
